module.exports = "https://trybtryb-legacy.web.app/img/adam.597bdcd9.webp";